import {
  ArrowRight,
  Block,
  BlockProps,
  Link,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { BANNER_Z_INDEX, IS_MEZO_MAINNET, links } from "#/shared/constants"

type MatsnetTopBannerProps = BlockProps

function MatsnetTopBanner(props: MatsnetTopBannerProps) {
  const [css, theme] = useStyletron()

  if (IS_MEZO_MAINNET) return null

  return (
    <Block
      position="relative"
      top={0}
      left={0}
      width="100%"
      maxHeight={theme.sizing.scale1200}
      paddingTop={theme.sizing.scale500}
      paddingBottom={theme.sizing.scale500}
      backgroundColor={theme.colors.warning}
      overrides={{
        Block: {
          style: { zIndex: BANNER_Z_INDEX, textAlign: "center" },
        },
      }}
      {...props}
    >
      This is Testnet.
      <Link
        href={links.MEZO_MAINNET}
        className={css({
          display: "inline-flex",
          alignItems: "center",
          marginLeft: theme.sizing.scale400,
          marginRight: theme.sizing.scale400,
          ":visited": {
            color: `${theme.colors.black} !important`,
          },
          gap: theme.sizing.scale300,
        })}
      >
        Switch to Mainnet
        <ArrowRight size={theme.sizing.scale600} />
      </Link>
    </Block>
  )
}

export default MatsnetTopBanner
